'use client';
import { jsx } from 'react/jsx-runtime';
import { ProgressBarContextProvider } from './progress-bar.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const ProgressBarContainer = renderWithRef('ProgressBarContainer', void 0, (e, n)=>jsx(ProgressBarContextProvider, {
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: n,
            classNames: [
                'swan-progress-bar-container'
            ],
            props: e,
            children: e.children
        })
    }));

export { ProgressBarContainer };
